/**
 * Health endpoint — the first slice injected into the shared api, and the pattern
 * every later feature follows.
 */
import type { Health } from '@inbound/contract';

import { apiSlice } from './api-slice.js';

export const healthApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getHealth: build.query<Health, void>({
      // /health sits outside the /api prefix on the server (probes and the login
      // page both need it before there is a session), so the path escapes baseUrl.
      query: () => ({ url: '/../health' }),
      providesTags: ['Health'],
      // S03 wants a *real* connection indicator, which means it has to keep
      // asking. 15 s matches the notification poll agreed in Q8.
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetHealthQuery } = healthApi;
